import { render, staticRenderFns } from "./CartEntryPromoUpsell.vue?vue&type=template&id=32427474&scoped=true"
import script from "./CartEntryPromoUpsell.vue?vue&type=script&lang=js"
export * from "./CartEntryPromoUpsell.vue?vue&type=script&lang=js"
import style0 from "./CartEntryPromoUpsell.vue?vue&type=style&index=0&id=32427474&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32427474",
  null
  
)

export default component.exports